'use strict';

var _themeSections = require('@shopify/theme-sections');

var _lazyImage = require('../modules/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.register)('hair-story', {
  onLoad: function onLoad() {
    var images = (0, _functional.getElements)('[data-module="lazy-image"]', {
      context: this.container
    });

    images.forEach(function (image) {
      new _lazyImage2.default(image);
    });
  }
});